import {Injectable} from "@angular/core";
import {HttpClient, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {GeneralConfigDto} from "../model/general-config.dto";

@Injectable({
  providedIn: 'root'
})
export class GeneralConfigService {

  constructor(private http: HttpClient) {
  }

  getGeneralConfig(): Observable<HttpResponse<GeneralConfigDto>> {
    return this.http.get<GeneralConfigDto>(`/app/general-config`, {observe: "response"})
  }

  getStateNames(): Observable<HttpResponse<string[]>> {
    return this.http.get<string[]>(`/app/general-config/stateNames`, {observe: "response"})
  }
}
